"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.toTimestamp = void 0;
var moment_1 = __importDefault(require("moment"));
var toTimestamp = function (date) {
    if (!date) {
        return undefined;
    }
    return moment_1["default"](date, 'YYYY-MM-DDTHH:mm:ssZ').valueOf();
};
exports.toTimestamp = toTimestamp;
//# sourceMappingURL=date.js.map